import React from "react";
import { Table } from "react-bootstrap";
import { ReferralTableHeader } from "../../referrals/Tables/ReferralTableHeader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { get_vendor_referrals } from "../../../../store/actions/vendorReferrals/vendorreferralsactions";
import { ReferralTableBody } from "../../referrals/Tables/ReferralTableBody";

class ReferralsProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      referrals: [],
      pageNo: 1,
      start: 0,
      end: 10,
      referralcode: "",
    };
  }
  componentDidMount() {
    const token = this.props.auth.user.accessToken;
    this.props.get_vendor_referrals(token);
    const referralcode = this.props.auth.user.VendorUser.referral_code;
    this.setState({
      referrals: this.props.referrals ? this.props.referrals : [],
      referralcode: referralcode,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.referrals &&
      this.state.referrals.length !== nextProps.referrals &&
      nextProps.referrals.length
    ) {
      this.setState({ referrals: nextProps.referrals });
    }
  }
  renderTableDataBody = () => {
    const referralsData = this.state.referrals;
    const { start, end } = this.state;
    return (
      <React.Fragment>
        {referralsData.slice(start, end).map((data) => (
          <ReferralTableBody
            refuserId={data?._id}
            refree={{
              src: data.referred_id?.profile_photo,
              name: data.name,
            }}
            referalRole={data?.referred_id_Model}
            refDate={new Date(data?.createdAt)}
            enrollDate={new Date(data?.enroll_date)}
            lastActivity={data?.last_activity}
            referralQualified={data?.referral_qualified ? "Yes" : "No"}
            amount="₹ -"
            receivingOrgID="-"
            receivingOrgName="-"
          />
        ))}
      </React.Fragment>
    );
  };
  render() {
    return (
      <div>
        <div className={`col-12 p-0 user-table-reusable-superadmin`}>
          <Table>
            <thead>
              <ReferralTableHeader
                headOne={
                  <>
                    Refereed <br />
                    User ID
                  </>
                }
                headTwo={
                  <>
                    Referred User
                    <br /> Name
                  </>
                }
                headThree={
                  <>
                    Referred <br />
                    Role
                  </>
                }
                headFour={
                  <>
                    Referred <br />
                    Date
                  </>
                }
                headFive={
                  <>
                    Enrollment <br />
                    Date
                  </>
                }
                headSix="Last Activity"
                headSeven={
                  <>
                    Referral <br />
                    Qualified
                  </>
                }
                headEight="Amount"
                headNine={
                  <>
                    Receiving Org <br />
                    ID
                  </>
                }
                selectedTab={2}
                headTen={
                  <>
                    Receiving Org <br />
                    Name
                  </>
                }
              />
            </thead>
            <tbody>{this.renderTableDataBody()}</tbody>
          </Table>
        </div>
      </div>
    );
  }
}

// export default ReferralsProfile;

ReferralsProfile.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  referrals: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  referrals: state.vendorreferrals.vendorReferrals,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_vendor_referrals,
})(withRouter(ReferralsProfile));
